import { useEffect, useRef } from 'react';

import { Box } from '@chakra-ui/react';

import { Spinner } from './../../atoms';
import { Alert } from './../alert';
import { InfiniteScrollProps } from './infinite-scroll.props';

export const InfiniteScroll = ({
    children,
    onNextPage,
    errorMessage,
    isLoading = false,
    isError = false,
    hasMorePages = true,
    wrapperProps,
    ...props
}: InfiniteScrollProps) => {
    const observerTargetRef = useRef(null);

    useEffect(() => {
        if (isLoading || !hasMorePages) {
            return;
        }

        const target = observerTargetRef.current;
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    if (hasMorePages) {
                        onNextPage();
                    }
                }
            },
            {
                threshold: 0,
                rootMargin: '0px 0px 0px 0px',
            },
        );

        target && observer.observe(target);

        return () => {
            target && observer.unobserve(target);
        };
    }, [hasMorePages, isLoading, observerTargetRef, onNextPage]);

    return (
        <Box {...wrapperProps}>
            <Box {...props}>{children}</Box>
            <Box ref={observerTargetRef} />
            {isLoading ? <Spinner mt={6} /> : null}
            {isError ? (
                <Alert status={'error'} mt={6}>
                    {errorMessage}
                </Alert>
            ) : null}
        </Box>
    );
};
